import React from "react";

// World-map outline supplied by the founder. Rendered without pins/legend so
// the page stays visually calm, the copy above already speaks to reach.
const MAP_IMAGE = "/assets/world-map.webp";

export default function PresenceMap() {
  return (
    <div className="md-presence-map-wrap md-presence-map-wrap-mapOnly" data-testid="presence-map">
      <div className="md-presence-map-art">
        <img
          src={MAP_IMAGE}
          alt="World map illustrating MindDhara's worldwide reach"
          className="md-presence-map-img"
          loading="lazy"
        />
      </div>
    </div>
  );
}
